import styled from 'styled-components';

import { theme } from '@notino/react-styleguide';

export const Wrapper = styled.div`
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Footer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
`;

export const Buttons = styled.div`
  width: 100%;
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > * {
    width: 100%;
  }
`;

export const ProfessionalProductsWarning = styled.div`
  background-color: ${theme.color.background.secondary};
  padding: 12px;
  display: flex;
  gap: 8px;
  margin-top: 1rem;

  svg {
    min-width: 20px;
    height: 20px;
    width: 20px;
  }
`;
